import Container from 'components/Container/Container';
import BgSvg from 'components/Img/aircraft-min.jpg';
import config from 'config';
import { memo, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useSelector } from 'react-redux';
import { RedocStandalone } from 'redoc';

import { Box, Grid, Typography } from '@mui/material';

const tryJsonParse = (json: any, _default = {}) => {
  try {
    if (typeof json === 'string') {
      return JSON.parse(json) || _default;
    }
  } catch (e) {
    console.error(e.message);
    console.error(json.slice(421, 20), 'message');
    return _default;
  }

  return json || _default;
};

const Home = memo(
  () => {
    const title = 'Bringer Parcel Xpress';
    // eslint-disable-next-line
    const description =
      'Ship anywhere in the world with a click. Our online tools let you ship with confidence without downloading software';

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'docs' does not exist on type 'DefaultRoo... Remove this comment to see the full error message
    const retailerDocs = useSelector((state) => state.docs.result.docs);

    // console.log(retailerDocs, 'retailerDocs');

    useEffect(() => {
      // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
      const main = document.getElementById('content').getElementsByTagName('main')[0];
      let parent = main;

      const overflows: any = [];

      while (parent) {
        const hasOverflow = getComputedStyle(parent).overflow;
        if (hasOverflow !== 'visible') {
          overflows.push(parent);
          parent.style.setProperty('overflow', 'initial');
        }
        // @ts-expect-error ts-migrate(2322) FIXME: Type 'HTMLElement | null' is not assignable to typ... Remove this comment to see the full error message
        parent = parent.parentElement;
      }
      return () => {
        // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'node' implicitly has an 'any' type.
        overflows.forEach((node) => {
          node.style.removeProperty('overflow');
        });
      };
    });

    const ldjson = {
      '@context': 'http://schema.org',
      '@type': 'WebSite',
      url: config.domain,
      name: config.app.title,
      alternateName: 'Bringer',
      image: `${config.domain}/bpx-logo-white.png`,
      sameAs: [
        'https://www.facebook.com/Bringer',
        'https://instagram.com/Bringer',
        'https://www.linkedin.com/company/Bringer/',
        'https://twitter.com/@Bringer',
      ],
    };

    const ldjsonOrg = {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: config.app.title,
      legalName: 'Bringer CORP',
      email: `mailto:contact@${config.host}`,
      url: config.domain,
      logo: `${config.domain}/bpx-logo-white.png`,
      sameAs: [
        'https://www.facebook.com/Bringer',
        'https://instagram.com/Bringer',
        'https://www.linkedin.com/company/Bringer/',
        'https://twitter.com/@Bringer',
      ],
    };

    return (
      <>
        <Helmet>
          <title>{title}</title>
          <link rel="canonical" href={`${config.domain}/`} />
          <meta name="description" content={description} />
          <meta property="og:title" content={title} />
          <meta property="twitter:title" content={title} />
          <meta name="og:description" content={description} />
          <meta name="twitter:description" content={description} />
          <meta property="og:type" content="website" />
          <meta name="robots" content="index, follow" />
          <script type="application/ld+json">{JSON.stringify(ldjson)}</script>
          <script type="application/ld+json">{JSON.stringify(ldjsonOrg)}</script>
        </Helmet>
        <Box
          sx={{
            display: 'flex',
            color: '#fff',
            backgroundImage: `url(${BgSvg})`,
            minHeight: 300,
            width: 'calc(100% + 2px)',
            backgroundSize: 'cover',
            backgroundPosition: 'center center',
          }}
        >
          <Container>
            <Grid
              container
              alignItems="center"
              sx={{
                height: '100%',
              }}
            >
              <Grid item xs={12} sm={6}>
                <Typography variant="h3" component="h1" color="inherit" gutterBottom>
                  Documentation
                </Typography>
              </Grid>
            </Grid>
          </Container>
        </Box>
        {process.browser && (
          <Box
            sx={{
              '& a[href=https://github.com/Redocly/redoc]': {
                display: 'none',
              },
            }}
          >
            <RedocStandalone
              spec={tryJsonParse(retailerDocs)}
              // options={{
              //   theme: { colors: { primary: { main: '#dd5522' } } },
              // }}
            />
          </Box>
        )}
      </>
    );
  },
  () => true
);

export default Home;
